var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLlamadaIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iconos_menu_flotante"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconos_menu_flotante",
    clipPath: "url(#clip-iconos_menu_flotante)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ico_phone",
    d: "M26.1,4.162q-.8-.5-1.631-.923A1.958,1.958,0,0,0,23.605,3a1.369,1.369,0,0,0-1.253,1.029q-.693,1.74-1.277,3.518a1.088,1.088,0,0,0,.519,1.392l1.982,1.121q-2.424,4.482-5.184,8.761L16.416,17.7a1.253,1.253,0,0,0-.616-.177,1.2,1.2,0,0,0-.885.425q-1.292,1.38-2.483,2.837a1.311,1.311,0,0,0,.351,2.191c.528.336,1.07.643,1.631.926a4.871,4.871,0,0,0,2.206.628,4,4,0,0,0,2.156-.7c2.2-1.362,4.181-3.63,6.237-7.1h0c2.055-3.474,3.07-6.278,3.2-8.831A3.753,3.753,0,0,0,26.1,4.162Zm1.224,3.692c-.115,2.4-1.091,5.078-3.067,8.413v.024h0c-1.976,3.332-3.863,5.488-5.936,6.782a3.152,3.152,0,0,1-1.7.569,4.022,4.022,0,0,1-1.8-.534c-.531-.268-1.056-.566-1.554-.885-.262-.165-.369-.295-.38-.389s.041-.254.239-.5c.778-.952,1.6-1.89,2.444-2.792.05-.053.147-.144.23-.144a.419.419,0,0,1,.18.062l.634.36,1.348.764.725.413.454-.7c1.843-2.857,3.6-5.824,5.219-8.817l.41-.764s-.066-.041-.752-.428-1.993-1.118-1.993-1.118c-.136-.08-.189-.121-.115-.348.377-1.162.8-2.327,1.259-3.462.2-.475.383-.475.442-.475a1.156,1.156,0,0,1,.478.142c.528.268,1.053.566,1.557.885A2.875,2.875,0,0,1,27.327,7.854Z",
    transform: "translate(-8.104 -1.763)",
    fill: "#001e50",
    stroke: "#001e50",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlamadaIco);
export default __webpack_public_path__ + "static/media/llamada_ico.0a94a8f8260a74be71f188fddfd5fbe7.svg";
export { ForwardRef as ReactComponent };